import { render, staticRenderFns } from "./LiveDetect.vue?vue&type=template&id=4b7dbe26&scoped=true&"
import script from "./LiveDetect.vue?vue&type=script&lang=js&"
export * from "./LiveDetect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dbe26",
  null
  
)

export default component.exports